const hy = {
  title: `Ինչպես օգտագործել`,
  subTitle: '(UXCG - Գտնում ենք Ձեր պրոդուկտի խնդիրների լուծումները)',
  description:
    'UXCG-ը անվճար գործիք է, որը օգնում է հասկանալ պրոդուկտ և պրոյեկտ մենեջմենթի ամենատարածված խնդիրները՝ կոգնիտիվ գիտության և վարքագծային տնտեսագիտության տեսանկյունից։',
  defaultStage: 'Թիմի կազմավորում',
  selectStageTxt: 'Ընտրեք ձեր պրոյեկտի փուլը',
  relevantQuestionsTxt: 'Համապատասխան հարցեր ձեր պրոյեկտի համար',
};

export default hy;
